import { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { dspLogin, otpLogin } from 'features/login/loginSlice'

const useLogin = () => {
  const dispatch = useDispatch()
  const { otp, accountId, adAccountId } = Object.fromEntries(
    new URLSearchParams(window.location.search)
  )
  if (otp && accountId && adAccountId) {
    sessionStorage.setItem(
      'otp',
      JSON.stringify({
        otp,
        accountId,
        adAccountId,
      })
    )
  }
  useEffect(() => {
    if (sessionStorage.getItem('otp')) {
      dispatch(otpLogin())
    } else {
      dispatch(dspLogin())
    }
  }, [dispatch])
}

export default useLogin
